import { render } from "./Datetime.vue?vue&type=template&id=72cbe08a&scoped=true"
import script from "./Datetime.vue?vue&type=script&lang=js"
export * from "./Datetime.vue?vue&type=script&lang=js"

import "./Datetime.vue?vue&type=style&index=0&id=72cbe08a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cbe08a"]])

export default __exports__